import { useNavigate } from 'react-router';

import { useSelectedUser } from 'hooks/useSelectedUser/useSelectedUser';
import { AddUserContainer } from '../../addUser/AddUserContainer';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { AppRouteWithParams } from 'routing/AppRoute.enum';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

import * as Styled from './UserActions.styles';
import { LogoutUserContainer } from './logoutUser/LogoutUserContainer';

export const UserActions = () => {
  const navigate = useNavigate();
  const { selectedUser, setSelectedUser } = useSelectedUser();
  const { perms } = usePermissions();
  const { formatMessage } = useLocale();

  if (!selectedUser) return null;

  const canViewHistory = perms?.[Functionality.HISTORIA]?.view;

  return (
    <Styled.ActionButtonWrapper>
      <ActionButton
        type="history"
        onClick={() => navigate(AppRouteWithParams.userHistory.get({ id: selectedUser.id }))}
        disabled={!canViewHistory}
        customTooltipText={!canViewHistory ? formatMessage({ id: AppMessages['common.noPermissions'] }) : undefined}
      />

      <ActionButton
        type="permissions"
        onClick={() => navigate(AppRouteWithParams.userDataPermissions.get({ id: selectedUser.id }))}
      />

      <AddUserContainer type="copy" user={selectedUser} />

      {selectedUser.zalogowany && <LogoutUserContainer selectedUser={selectedUser} setSelectedUser={setSelectedUser} />}
    </Styled.ActionButtonWrapper>
  );
};
